<template>
    <div>
        <div class="chartContainer">
            <h1>Gavekortbruk per måned</h1>
            <div class="chart">
                <div id="salesPerMonthPerRestaurantChart"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import ApexCharts from 'apexcharts'
    export default{
        props:{
            chart_data: Object
        },
        mounted(){
            this.MakeStackedCharts(this.chart_data);
        },
        methods: {
            MakeStackedCharts(chart_data) {        
                var barOptions = {
                    chart: {
                        type: 'bar',
                        stacked:true,
                        toolbar: {
                            show: true
                        },
                        zoom: {
                            enabled: true
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                        },
                    },
                    series: this.MakeSeries(this.chart_data),
                    xaxis: {
                        categories: MONTH_NAMES,
                    },
                    fill: {
                        opacity: 1
                    },
                }
                var barChart = new ApexCharts(document.querySelector("#salesPerMonthPerRestaurantChart"), barOptions);
                barChart.render();  
            },
            ToTimestamp(strDate){
                var datum = Date.parse(strDate);
                return datum;
            },
            MakeSeries(rawData){
                var series = []
                Object.keys(rawData).map(function(key, index) {
                    series.push(
                        {
                            name: key,
                            data: Object.values(rawData[key])
                        }
                    );
                });
                return series;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/SalesPerMonthPerRestaurantChart.vue